import TheProductsReport from '@/views/reports/products/TheProductsReport';
import ThePaymentMethodsReport from '@/views/reports/payment-methods/ThePaymentMethodsReport';
import TheConversionsReport from '@/views/reports/conversions/TheConversionsReport';

export default [

    {
        path: '/reports/products',
        name: 'reports-products',
        component: TheProductsReport,
        meta: {
            requiresAuth: true,
            menuPage: 'reports-products'
        }
    },

    {
        path: '/reports/payment-methods',
        name: 'payment-methods',
        component: ThePaymentMethodsReport,
        meta: {
            requiresAuth: true,
            menuPage: 'reports-payment-methods'
        }
    },

    {
        path: '/reports/conversions',
        name: 'conversions',
        component: TheConversionsReport,
        meta: {
            requiresAuth: true,
            menuPage: 'reports-conversions'
        }
    },
];